import { useCallback, useRef } from 'react';

type UsePreAuthPromiseResponse = {
  setPreAuthPromise: (resolve: () => void, reject: (error: unknown) => void) => void;
  resolvePreAuthPromise: () => void;
  rejectPreAuthPromise: (error: unknown) => void;
  hasActivePreAuthPromise: () => boolean;
};

export const usePreAuthPromise = (): UsePreAuthPromiseResponse => {
  const preAuthPromiseRef = useRef<{
    resolve: () => void;
    reject: (error: unknown) => void;
  } | null>(null);

  const setPreAuthPromise = useCallback((resolve: () => void, reject: (error: unknown) => void) => {
    preAuthPromiseRef.current = { resolve, reject };
  }, []);

  const resolvePreAuthPromise = useCallback(() => {
    if (preAuthPromiseRef.current) {
      preAuthPromiseRef.current.resolve();
      preAuthPromiseRef.current = null;
    }
  }, []);

  const rejectPreAuthPromise = useCallback((error: unknown) => {
    if (preAuthPromiseRef.current) {
      preAuthPromiseRef.current.reject(error);
      preAuthPromiseRef.current = null;
    }
  }, []);

  const hasActivePreAuthPromise = useCallback(() => preAuthPromiseRef.current !== null, []);

  return {
    setPreAuthPromise,
    resolvePreAuthPromise,
    rejectPreAuthPromise,
    hasActivePreAuthPromise,
  };
};
